import { FC, useCallback } from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { useModal } from "core"
import { LinkTo } from "shared/constants/linkTo"
import {
  SuccessModalButton,
  SuccessModalContainer,
  SuccessModalContent,
  SuccessModalDescription,
  SuccessModalTitle,
} from "./MagistracyApplicationSuccessModal.styles"

export const MagistracyApplicationSuccessModal: FC = () => {
  const { t } = useTranslation()
  const modal = useModal()
  const history = useHistory()

  const handleGoHome = useCallback(() => {
    modal.hide()
    history.push(LinkTo.explore)
  }, [history, modal])

  return (
    <SuccessModalContainer direction="column" justify="center" align="center">
      <SuccessModalContent>
        <SuccessModalTitle>{t("magistracyPage.success.title")}</SuccessModalTitle>
        <SuccessModalDescription>{t("magistracyPage.success.description")}</SuccessModalDescription>
        <SuccessModalButton type="button" onClick={handleGoHome}>
          {t("magistracyPage.success.button")}
        </SuccessModalButton>
      </SuccessModalContent>
    </SuccessModalContainer>
  )
}
import { FC, useCallback } from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { useModal } from "core"
import { LinkTo } from "shared/constants/linkTo"
import {
  SuccessModalButton,
  SuccessModalContainer,
  SuccessModalContent,
  SuccessModalDescription,
  SuccessModalTitle,
} from "./MagistracyApplicationSuccessModal.styles"

export const MagistracyApplicationSuccessModal: FC = () => {
  const { t } = useTranslation()
  const modal = useModal()
  const history = useHistory()

  const handleGoHome = useCallback(() => {
    modal.hide()
    history.push(LinkTo.explore)
  }, [history, modal])

  return (
    <SuccessModalContainer direction="column" justify="center" align="center">
      <SuccessModalContent>
        <SuccessModalTitle>{t("magistracyPage.success.title")}</SuccessModalTitle>
        <SuccessModalDescription>{t("magistracyPage.success.description")}</SuccessModalDescription>
        <SuccessModalButton type="button" onClick={handleGoHome}>
          {t("magistracyPage.success.button")}
        </SuccessModalButton>
      </SuccessModalContent>
    </SuccessModalContainer>
  )
}
